import { useTranslation } from 'react-i18next';
import Switch from 'react-switch';
import { switchProps } from '../../config/config';
import { AllergenFilter } from '../../../../api-types/models/UserDto';
import { ReactNode, useCallback, useEffect, useState } from 'react';
import { useUpdateAllergiesMutation } from '../../../../api/userApi';

interface IProps {
    allergies: AllergenFilter;
}

export function Allergies({ allergies }: Readonly<IProps>): ReactNode {
    const { t } = useTranslation();
    const [updateAllergies] = useUpdateAllergiesMutation();
    const [allergiesState, setAllergiesState] = useState(allergies);

    useEffect(() => {
        setAllergiesState(allergies);
    }, [allergies]);

    const handleUpdateAllergies = useCallback(
        (allergy: keyof AllergenFilter, value: boolean) => {
            setAllergiesState({ ...allergiesState, [allergy]: value });
            updateAllergies({ allergen: allergy, value });
        },
        [allergiesState, updateAllergies]
    );

    return (
        <div className='alergies-options box'>
            <div className='options-title'>{t('allergies')}</div>
            <div className='options-mutable options-text'>
                {t('allergies_text')}
            </div>
            {allergiesState &&
                Object.keys(allergiesState).map((allergen) => {
                    const allergenKey = allergen as keyof AllergenFilter;
                    return (
                        <div className='options-text-switch' key={allergen}>
                            {/* Fish already have different translation */}
                            {allergen !== 'FISH'
                                ? t(allergen.toLowerCase())
                                : t('fishAl')}
                            <Switch
                                checked={allergiesState[allergenKey] === true}
                                onChange={(value: boolean) =>
                                    handleUpdateAllergies(allergenKey, value)
                                }
                                {...switchProps}
                            />
                        </div>
                    );
                })}
        </div>
    );
}
